import { IssueEntity } from 'serviceWorker/repository/issue/entity';
import { getCompanies } from 'serviceWorker/services/companies';
import {
  ChartValuesAndLabels,
  FilterValues,
  IssueChart,
} from 'shared/types/analytics';
import { HashMap, LabelledEntity } from 'shared/types/commonView';
import {
  increaseEntitySeries,
  increaseNoneSeries,
  toSortedValuesAndLabels,
} from '../seriesCreation';
import { filterIssuesByChartFilters } from '../issueChartFilters';

export async function createSeriesAndLabelsFromIssuesWithFilters(
  issues: IssueEntity[],
  filters: FilterValues,
  timezone: string
): Promise<ChartValuesAndLabels> {
  const originators = {};
  const companiesMap = (await getCompanies()).reduce((map, company) => {
    map.set(company._id, { _id: company._id, label: company.shortLabel });
    return map;
  }, new Map<string, LabelledEntity>());

  const filteredIssues = filterIssuesByChartFilters(issues, IssueChart.originator, filters, timezone);

  const reducedToOriginatorsSummary = filteredIssues.reduce<
    HashMap<number>
  >((result, issue) => {
    const subcontractors = issue.primaryData.subcontractors || [];

    if (!subcontractors.length) {
      increaseNoneSeries(result, originators);
    } else {
      subcontractors.forEach((subcontractor) =>
        increaseEntitySeries(
          result,
          originators,
          companiesMap.get(subcontractor)!
        )
      );
    }

    return result;
  }, {});

  return toSortedValuesAndLabels(reducedToOriginatorsSummary, originators);
}
